import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { ChangeDigitalSignature } from '../model/change-digital-signature';
import { ChangeDigitalSignatureEventType } from '../change-digital-signature.event.type';

@Component({
	selector: 'app-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SummaryComponent implements OnInit, OnDestroy {

	@Input() changeDigitalSignatureData: ChangeDigitalSignature;
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="summary"]';
	public active = false;

	constructor() { }

	ngOnInit() {
		AppEventDispatcher.listen(ChangeDigitalSignatureEventType.STEPS.CHANGE_DG_SIGNATURE_WARNING, data => {
			if (data.show) {
				this.active = true;
				this.show();

				this.showStepButtons.emit(true);
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangeDigitalSignatureEventType.STEPS.CHANGE_DG_SIGNATURE_WARNING);
	}

	show() {
		AppEventDispatcher.dispatch(ChangeDigitalSignatureEventType.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});

	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-digital-signature/summary/summary.component.ts